module.exports = __webpack_public_path__ + "static/media/master-card-logo.1ae8b901.svg";